import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";

import '../../locales/splash/i18n';

import React from "react";
import { SnackbarProvider } from "notistack";
import GymSplash from "splash_components/GymSplash/GymSplash";
import SnackbarCloseButton from "splash_components/SnackbarCloseButton/SnackbarCloseButton";

export default function GymSplashRoot() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#004080",
      },
      secondary: {
        main: "#FFFFFF",
      },
    },
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4500}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
    >
      <ThemeProvider theme={theme}>
        <GymSplash />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
